<template>
    <edit-view-base :filter="filter" :has-card-view="false" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Address', apiMethod: 'Addresses', form: () => import('../forms/AddressForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Contact Address', apiMethod: 'ContactAddresses', parentForeignKey: 'addressId', form: () => import('../forms/ContactAddressForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Contacts', value: 'addressId', isCard: true, table: () => import('../tables/ContactAddressesTable') },
                    { text: 'Facilities', value: 'addressId', table: () => import('../tables/FacilitiesTable') },
                    { text: 'Labs', value: 'addressId', table: () => import('../tables/LabsTable') },
                ],
                mainForm: () => import('../forms/AddressForm'),
                claimName: 'Addresses',
                apiMethod: 'Addresses',
            }
        }
    };
</script>
